export type ENVIRONMENT = 'production' | 'development';
const ENVIRONMENT_PREFIX = /^(REACT_APP_|FF_)/i;

// Utility function to cast string boolean from incoming json values to actual booleans
function castStringBooleans(obj: any): any {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj === 'string') {
    const lowerStr = obj.toLowerCase();
    if (lowerStr === 'true') return true;
    if (lowerStr === 'false') return false;
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(castStringBooleans);
  }

  if (typeof obj === 'object') {
    const result: any = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(obj)) {
      result[key] = castStringBooleans(value);
    }
    return result;
  }

  return obj;
}

export class ConfigService {
  constructor(private env: any = {}) {
    this.env = Object.keys(this.env)
      .reduce((acc: any, key: string) => {
        acc[key.replace(ENVIRONMENT_PREFIX, '')] = this.env[key];

        return acc;
      }, {});
  }

  get<T = string>(key: string): T {
    return this.env[key];
  }

  set(key: string, value: any): void {
    this.env[key] = value;
  }

  getEnv(): ENVIRONMENT {
    return this.env.NODE_ENV;
  }

  async load(url: string): Promise<void> {
    const config = await fetch(url).then(resp => resp.json()).catch(() => ({}));

    this.env = {
      ...this.env,
      ...castStringBooleans(config),
    };
  }
}
